import { useEffect } from 'react';
import axios from 'axios';
import { api } from '@/services/api.config';
import type { ELinxSettingsUpdateRequest, ELinxSettingsResponse, ApiResponse, PortalUser } from 'vopay';

export default function useELinxSettings() {
  const source = axios.CancelToken.source();

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  async function fetchELinxSettings(params: PortalUser): Promise<ELinxSettingsResponse> {
    try {
      const res = await api.fetchPaylinkSettings(params, source);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (err) {
      console.error('Fetch eLinx settings failed:', err);
      throw err;
    }
  }

  async function updateELinxSettings(params: ELinxSettingsUpdateRequest, bearer?: string): Promise<ApiResponse> {
    try {
      const res = await api.updateELinxSettings(params, source, bearer);

      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }

      return res;
    } catch (err) {
      console.error('Update eLinx settings failed:', err);
      throw err;
    }
  }

  return {
    fetchELinxSettings,
    updateELinxSettings,
  };
}
